import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const TableSkeleton = ({ widths = [], rows = 3, cols = [] }) => {
  const rowsArray = Array.from({ length: rows });

  return (
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr>
          {cols.map((_, i) => (
            <th key={i} style={{ padding: "0.8rem", width: widths[i] }}>
              <Skeleton height={20} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rowsArray.map((_, i) => (
          <tr key={i}>
            {cols.map((_, j) => (
              <td key={j} style={{ padding: "0.8rem", width: widths[j] }}>
                <Skeleton height={16} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
